import React, { useState } from "react";
import {
  useClearRefinements,
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";

function BathMobileRefinement() {
  //const { items, canRefine, refine } = useCurrentRefinements();
  // bedrooms
  const currentProps = useCurrentRefinements();
  const currentItems = currentProps.items;
  const refineCurrent = currentProps.refine;
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,

    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "noOfBedrooms", sortBy: ["name:asc"] });

  const propBaths = useRefinementList({
    attribute: "noOfBathrooms",
    sortBy: ["name:asc"],
  });
  const propBathsItems = propBaths.items;
  const propBathsRefine = propBaths.refine;

  const [open, setOpen] = useState(false);
  //

  //bathrooms
  const currentPropsBath = useCurrentRefinements();
  const currentItemsBath = currentPropsBath.items;
  const refineCurrentBath = currentPropsBath.refine;
  // end bath

  const arr = currentItems.find((c) => c.attribute === "noOfBedrooms");

  const arrBath = currentItemsBath.find((c) => c.attribute === "noOfBathrooms");
  // console.log(arr);

  const clearBds = useClearRefinements({
    includedAttributes: ["noOfBedrooms"],
  });
  const clearBaths = useClearRefinements({
    includedAttributes: ["noOfBathrooms"],
  });
  return (
    <div className="  grid grid-flow-col">
      <div
        onClick={() => {
          clearBaths.refine();
        }}
        className={
          " flex flex-shrink-0 cursor-pointer items-center justify-center rounded-l-md border   px-5 py-2 font-semibold  " +
          (arrBath === undefined
            ? "border-zote-blue bg-blue-50 text-zote-secondary"
            : "  border-gray-300")
        }
      >
        Any
      </div>

      {propBathsItems?.map((item, index) => {
        const existsBath =
          arrBath?.refinements.find((el) => el.value === item.value)?.value !=
          undefined;

        return (
          <div
            key={item.value}
            onClick={() => {
              refineCurrentBath(item.value);
              propBathsRefine(item.value);
            }}
            className={
              "  flex flex-shrink-0 cursor-pointer items-center justify-center border      px-5 py-2 font-semibold text-gray-900" +
              (existsBath
                ? " border-zote-blue bg-blue-100 text-zote-secondary "
                : " border-gray-300 ") +
              (index === propBathsItems.length - 1
                ? " rounded-r-md "
                : " border-b border-l border-r-0 border-t ")
            }
          >
            {item.value}
          </div>
        );
      })}
    </div>
  );
}

export default BathMobileRefinement;
